import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow, A11y, FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';

// Import Primary images for carousel
import HutaC6Auctor4Primary from '../assets/images/Builds/Huta C6 Auctor #4/Primary.jpg';
import HutaM6Auctor8Primary from '../assets/images/Builds/Huta M6 Auctor #8/Primary.JPEG';
import HutaM6Peritus2Primary from '../assets/images/Builds/Huta M6 Peritus #2 Green/Primary.jpg';
import HutaM6Peritus5Primary from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Primary.jpg';
import HutaM7Peritus3Primary from '../assets/images/Builds/Huta M7 Peritus #3/Primary.png';
import HutaM8Peritus6Primary from '../assets/images/Builds/Huta M8 Peritus #6/Primary.jpg';
import YutaC6Peritus1Primary from '../assets/images/Builds/Yuta C6 Peritus #1/Primary.jpg';

// Import Huta C6 Auctor #4 images
import HutaC6Auctor4_56 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -56.jpg';
import HutaC6Auctor4_57 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -57.jpg';
import HutaC6Auctor4_58 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -58.jpg';
import HutaC6Auctor4_59 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -59.jpg';
import HutaC6Auctor4_60 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -60.jpg';
import HutaC6Auctor4_61 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -61.jpg';
import HutaC6Auctor4_62 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -62.jpg';
import HutaC6Auctor4_63 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -63.jpg';
import HutaC6Auctor4_64 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -64.jpg';
import HutaC6Auctor4_65 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -65.jpg';
import HutaC6Auctor4_66 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -66.jpg';
import HutaC6Auctor4_67 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -67.jpg';
import HutaC6Auctor4_68 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -68.jpg';
import HutaC6Auctor4_69 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -69.jpg';
import HutaC6Auctor4_70 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -70.jpg';
import HutaC6Auctor4_71 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -71.jpg';
import HutaC6Auctor4_72 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -72.jpg';
import HutaC6Auctor4_73 from '../assets/images/Builds/Huta C6 Auctor #4/Vitae Guitars  - -73.jpg';

// Import Huta M6 Auctor #8 images
import HutaM6Auctor8_3236 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3236.JPEG';
import HutaM6Auctor8_3238 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3238.JPEG';
import HutaM6Auctor8_3241 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3241.JPEG';
import HutaM6Auctor8_3246 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3246.JPEG';
import HutaM6Auctor8_3248 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3248.JPEG';
import HutaM6Auctor8_3260 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3260.JPEG';
import HutaM6Auctor8_3273 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_3273-1.JPEG';
import HutaM6Auctor8_4820 from '../assets/images/Builds/Huta M6 Auctor #8/IMG_4820.JPEG';

// Import Huta M6 Peritus #2 Green images
import HutaM6Peritus2_695 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0695.jpg';
import HutaM6Peritus2_699 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0699.png';
import HutaM6Peritus2_701 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0701.png';
import HutaM6Peritus2_703 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0703.png';
import HutaM6Peritus2_705 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0705.png';
import HutaM6Peritus2_709 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0709.png';
import HutaM6Peritus2_712 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0712.png';
import HutaM6Peritus2_714 from '../assets/images/Builds/Huta M6 Peritus #2 Green/IMG_0714.png';

// Import Huta M6 Peritus Fluere #5 images
import HutaM6Peritus5_02 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -02.jpg';
import HutaM6Peritus5_03 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -03.jpg';
import HutaM6Peritus5_04 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -04.jpg';
import HutaM6Peritus5_05 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -05.jpg';
import HutaM6Peritus5_06 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -06.jpg';
import HutaM6Peritus5_07 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -07.jpg';
import HutaM6Peritus5_08 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -08.jpg';
import HutaM6Peritus5_09 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -09.jpg';
import HutaM6Peritus5_10 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -10.jpg';
import HutaM6Peritus5_11 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -11.jpg';
import HutaM6Peritus5_12 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -12.jpg';
import HutaM6Peritus5_13 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -13.jpg';
import HutaM6Peritus5_14 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -14.jpg';
import HutaM6Peritus5_15 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -15.jpg';
import HutaM6Peritus5_16 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -16.jpg';
import HutaM6Peritus5_17 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -17.jpg';
import HutaM6Peritus5_18 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -18.jpg';
import HutaM6Peritus5_19 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -19.jpg';
import HutaM6Peritus5_20 from '../assets/images/Builds/Huta M6 Peritus _Fluere_ #5/Vitae Guitars  - -20.jpg';

// Import Huta M7 Peritus #3 images
import HutaM7Peritus3_720 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0720.png';
import HutaM7Peritus3_722 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0722.png';
import HutaM7Peritus3_723 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0723.png';
import HutaM7Peritus3_728 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0728.png';
import HutaM7Peritus3_735 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0735.png';
import HutaM7Peritus3_737 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0737.png';
import HutaM7Peritus3_737Copy from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0737 - Copy.png';
import HutaM7Peritus3_738 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0738.png';
import HutaM7Peritus3_739 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0739.png';
import HutaM7Peritus3_743 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0743.png';
import HutaM7Peritus3_752 from '../assets/images/Builds/Huta M7 Peritus #3/IMG_0752.png';

// Import Huta M8 Peritus #6 images
import HutaM8Peritus6_46 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -46.jpg';
import HutaM8Peritus6_47 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -47.jpg';
import HutaM8Peritus6_48 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -48.jpg';
import HutaM8Peritus6_49 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -49.jpg';
import HutaM8Peritus6_50 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -50.jpg';
import HutaM8Peritus6_51 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -51.jpg';
import HutaM8Peritus6_52 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -52.jpg';
import HutaM8Peritus6_53 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -53.jpg';
import HutaM8Peritus6_54 from '../assets/images/Builds/Huta M8 Peritus #6/Vitae Guitars  - -54.jpg';

// Import Yuta C6 Peritus #1 images
import YutaC6Peritus1_22 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -22.jpg';
import YutaC6Peritus1_23 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -23.jpg';
import YutaC6Peritus1_24 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -24.jpg';
import YutaC6Peritus1_25 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -25.jpg';
import YutaC6Peritus1_26 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -26.jpg';
import YutaC6Peritus1_27 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -27.jpg';
import YutaC6Peritus1_28 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -28.jpg';
import YutaC6Peritus1_29 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -29.jpg';
import YutaC6Peritus1_30 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -30.jpg';
import YutaC6Peritus1_31 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -31.jpg';
import YutaC6Peritus1_32 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -32.jpg';
import YutaC6Peritus1_33 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -33.jpg';
import YutaC6Peritus1_34 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -34.jpg';
import YutaC6Peritus1_35 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -35.jpg';
import YutaC6Peritus1_36 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -36.jpg';
import YutaC6Peritus1_37 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -37.jpg';
import YutaC6Peritus1_38 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -38.jpg';
import YutaC6Peritus1_39 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -39.jpg';
import YutaC6Peritus1_40 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -40.jpg';
import YutaC6Peritus1_41 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -41.jpg';
import YutaC6Peritus1_42 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -42.jpg';
import YutaC6Peritus1_43 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -43.jpg';
import YutaC6Peritus1_44 from '../assets/images/Builds/Yuta C6 Peritus #1/Vitae Guitars  - -44.jpg';

// Import Hackistalker M6 Auctor #11 images
import HackistalkerM6Auctor11Primary from '../assets/images/Builds/Hackistalker M6 Auctor #11/primary_shrink.JPEG';
import HackistalkerM6Auctor11_2255 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2255_shrink.JPEG';
import HackistalkerM6Auctor11_2257 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2257_shrink.JPEG';
import HackistalkerM6Auctor11_2258 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2258_shrink.JPEG';
import HackistalkerM6Auctor11_2259 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2259_shrink.JPEG';
import HackistalkerM6Auctor11_2260 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2260_shrink.JPEG';
import HackistalkerM6Auctor11_2261 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2261_shrink.JPEG';
import HackistalkerM6Auctor11_2262 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2262_shrink.JPEG';
import HackistalkerM6Auctor11_2263 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2263_shrink.JPEG';
import HackistalkerM6Auctor11_2264 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2264_shrink.JPEG';
import HackistalkerM6Auctor11_2266 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2266_shrink.JPEG';
import HackistalkerM6Auctor11_2267 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2267_shrink.JPEG';
import HackistalkerM6Auctor11_2269 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2269_shrink.JPEG';
import HackistalkerM6Auctor11_2270 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2270_shrink.JPEG';
import HackistalkerM6Auctor11_2271 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2271_shrink.JPEG';
import HackistalkerM6Auctor11_2272 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2272_shrink.JPEG';
import HackistalkerM6Auctor11_2273 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2273_shrink.JPEG';
import HackistalkerM6Auctor11_2275 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2275_shrink.JPEG';
import HackistalkerM6Auctor11_2276 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2276_shrink.JPEG';
import HackistalkerM6Auctor11_2277 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2277_shrink.JPEG';
import HackistalkerM6Auctor11_2278 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2278_shrink.JPEG';
import HackistalkerM6Auctor11_2279 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2279_shrink.JPEG';
import HackistalkerM6Auctor11_2280 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2280_shrink.JPEG';
import HackistalkerM6Auctor11_2281 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2281_shrink.JPEG';
import HackistalkerM6Auctor11_2282 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2282_shrink.JPEG';
import HackistalkerM6Auctor11_2283 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2283_shrink.JPEG';
import HackistalkerM6Auctor11_2284 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2284_shrink.JPEG';
import HackistalkerM6Auctor11_2285 from '../assets/images/Builds/Hackistalker M6 Auctor #11/IMG_2285_shrink.JPEG';

// Import Huta M7 Auctor #10 images
import HutaM7Auctor10Primary from '../assets/images/Builds/Huta M7 Auctor #10/primary_shrink.JPEG';
import HutaM7Auctor10_31 from '../assets/images/Builds/Huta M7 Auctor #10/31_shrink.JPEG';
import HutaM7Auctor10_32 from '../assets/images/Builds/Huta M7 Auctor #10/32_shrink.JPEG';
import HutaM7Auctor10_35 from '../assets/images/Builds/Huta M7 Auctor #10/35_shrink.JPEG';
import HutaM7Auctor10_36 from '../assets/images/Builds/Huta M7 Auctor #10/36_shrink.JPEG';
import HutaM7Auctor10_37 from '../assets/images/Builds/Huta M7 Auctor #10/37_shrink.JPEG';
import HutaM7Auctor10_38 from '../assets/images/Builds/Huta M7 Auctor #10/38_shrink.JPEG';
import HutaM7Auctor10_39 from '../assets/images/Builds/Huta M7 Auctor #10/39_shrink.JPEG';
import HutaM7Auctor10_42 from '../assets/images/Builds/Huta M7 Auctor #10/42_shrink.JPEG';
import HutaM7Auctor10_43 from '../assets/images/Builds/Huta M7 Auctor #10/43_shrink.JPEG';
import HutaM7Auctor10_44 from '../assets/images/Builds/Huta M7 Auctor #10/44_shrink.JPEG';
import HutaM7Auctor10_45 from '../assets/images/Builds/Huta M7 Auctor #10/45_shrink.JPEG';
import HutaM7Auctor10_46 from '../assets/images/Builds/Huta M7 Auctor #10/46_shrink.JPEG';
import HutaM7Auctor10_2370 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2370_shrink.JPEG';
import HutaM7Auctor10_2377 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2377_shrink.JPEG';
import HutaM7Auctor10_2379 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2379_shrink.JPEG';
import HutaM7Auctor10_2381 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2381_shrink.JPEG';
import HutaM7Auctor10_2384 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2384_shrink.JPEG';
import HutaM7Auctor10_2385 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2385_shrink.JPEG';
import HutaM7Auctor10_2394 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2394_shrink.JPEG';
import HutaM7Auctor10_2401 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2401_shrink.JPEG';
import HutaM7Auctor10_2405 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2405_shrink.JPEG';
import HutaM7Auctor10_2413 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2413_shrink.JPEG';
import HutaM7Auctor10_2430 from '../assets/images/Builds/Huta M7 Auctor #10/IMG_2430_shrink.JPEG';

// Import Huta C7 Auctor #9 images
import HutaC7Auctor9Primary from '../assets/images/Builds/Huta C7 Auctor #9/primary_shrink.JPEG';
import HutaC7Auctor9_7272 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7272_shrink.JPEG';
import HutaC7Auctor9_7274 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7274_shrink.JPEG';
import HutaC7Auctor9_7276 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7276_shrink.JPEG';
import HutaC7Auctor9_7277 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7277_shrink.JPEG';
import HutaC7Auctor9_7278 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7278_shrink.JPEG';
import HutaC7Auctor9_7279 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7279_shrink.JPEG';
import HutaC7Auctor9_7280 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7280_shrink.JPEG';
import HutaC7Auctor9_7281 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7281_shrink.JPEG';
import HutaC7Auctor9_7283 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7283_shrink.JPEG';
import HutaC7Auctor9_7285 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7285_shrink.JPEG';
import HutaC7Auctor9_7289 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7289_shrink.JPEG';
import HutaC7Auctor9_7291 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7291_shrink.JPEG';
import HutaC7Auctor9_7294 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7294_shrink.JPEG';
import HutaC7Auctor9_7295 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7295_shrink.JPEG';
import HutaC7Auctor9_7296 from '../assets/images/Builds/Huta C7 Auctor #9/IMG_7296_shrink.JPEG';

// Import Hackistalker C6 Peritus #12 images
import HackistalkerC6Peritus12_1 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P1_shrink.JPEG';
import HackistalkerC6Peritus12_2 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P2_shrink.JPEG';
import HackistalkerC6Peritus12_3 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P3_shrink.JPEG';
import HackistalkerC6Peritus12_4 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P4_shrink.JPEG';
import HackistalkerC6Peritus12_5 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P5_shrink.JPEG';
import HackistalkerC6Peritus12_6 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P6_shrink.JPEG';
import HackistalkerC6Peritus12_7 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P7_shrink.JPEG';
import HackistalkerC6Peritus12_8 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P8_shrink.JPEG';
import HackistalkerC6Peritus12_9 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P9_shrink.JPEG';
import HackistalkerC6Peritus12_10 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P10_shrink.JPEG';
import HackistalkerC6Peritus12_11 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P11_shrink.JPEG';
import HackistalkerC6Peritus12_12 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P12_shrink.JPEG';
import HackistalkerC6Peritus12_13 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P13_shrink.JPEG';
import HackistalkerC6Peritus12_14 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P14_shrink.JPEG';
import HackistalkerC6Peritus12_15 from '../assets/images/Builds/Hackistalker C6 Peritus #12/HSC6P15_shrink.JPEG';

// Import Yuta M5B Auctor #13 images
import YutaM5BAuctor13Primary from '../assets/images/Builds/Yuta M5B Auctor #13/d015c1d4-6315-40ed-9c4c-44e702c71fe9.jpeg';
import YutaM5BAuctor13_5088 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5088-1_shrink.JPEG';
import YutaM5BAuctor13_5089 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5089_shrink.JPEG';
import YutaM5BAuctor13_5090 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5090_shrink.JPEG';
import YutaM5BAuctor13_5092 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5092_shrink.JPEG';
import YutaM5BAuctor13_5096 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5096_shrink.JPEG';
import YutaM5BAuctor13_5097 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5097_shrink.JPEG';
import YutaM5BAuctor13_5098 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5098_shrink.JPEG';
import YutaM5BAuctor13_5099 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5099_shrink.JPEG';
import YutaM5BAuctor13_5101 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5101_shrink.JPEG';
import YutaM5BAuctor13_5102 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5102_shrink.JPEG';
import YutaM5BAuctor13_5103 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5103_shrink.JPEG';
import YutaM5BAuctor13_5105 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5105_shrink.JPEG';
import YutaM5BAuctor13_5107 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5107_shrink.JPEG';
import YutaM5BAuctor13_5108 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5108_shrink.JPEG';
import YutaM5BAuctor13_5109 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5109_shrink.JPEG';
import YutaM5BAuctor13_5110 from '../assets/images/Builds/Yuta M5B Auctor #13/IMG_5110_shrink.JPEG';

const GallerySection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentBuildIndex, setCurrentBuildIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Build data with primary images and galleries
  const builds = [
    {
      id: 1,
      name: 'Huta M6 Peritus',
      primary: HutaM6Peritus2Primary,
      gallery: [
        HutaM6Peritus2Primary,
        HutaM6Peritus2_695, HutaM6Peritus2_699, HutaM6Peritus2_701, HutaM6Peritus2_703,
        HutaM6Peritus2_705, HutaM6Peritus2_709, HutaM6Peritus2_712, HutaM6Peritus2_714
      ]
    },
    {
      id: 2,
      name: 'Huta M7 Peritus',
      primary: HutaM7Peritus3Primary,
      gallery: [
        HutaM7Peritus3Primary,
        HutaM7Peritus3_720, HutaM7Peritus3_722, HutaM7Peritus3_723, HutaM7Peritus3_728,
        HutaM7Peritus3_735, HutaM7Peritus3_737, HutaM7Peritus3_737Copy, HutaM7Peritus3_738,
        HutaM7Peritus3_739, HutaM7Peritus3_743, HutaM7Peritus3_752
      ]
    },
    {
      id: 3,
      name: 'Huta C6 Auctor',
      primary: HutaC6Auctor4Primary,
      gallery: [
        HutaC6Auctor4Primary,
        HutaC6Auctor4_56, HutaC6Auctor4_57, HutaC6Auctor4_58, HutaC6Auctor4_59, HutaC6Auctor4_60,
        HutaC6Auctor4_61, HutaC6Auctor4_62, HutaC6Auctor4_63, HutaC6Auctor4_64, HutaC6Auctor4_65,
        HutaC6Auctor4_66, HutaC6Auctor4_67, HutaC6Auctor4_68, HutaC6Auctor4_69, HutaC6Auctor4_70,
        HutaC6Auctor4_71, HutaC6Auctor4_72, HutaC6Auctor4_73
      ]
    },
    {
      id: 4,
      name: 'Huta M6 Peritus "Fluere"',
      primary: HutaM6Peritus5Primary,
      gallery: [
        HutaM6Peritus5Primary,
        HutaM6Peritus5_02, HutaM6Peritus5_03, HutaM6Peritus5_04, HutaM6Peritus5_05, HutaM6Peritus5_06,
        HutaM6Peritus5_07, HutaM6Peritus5_08, HutaM6Peritus5_09, HutaM6Peritus5_10, HutaM6Peritus5_11,
        HutaM6Peritus5_12, HutaM6Peritus5_13, HutaM6Peritus5_14, HutaM6Peritus5_15, HutaM6Peritus5_16,
        HutaM6Peritus5_17, HutaM6Peritus5_18, HutaM6Peritus5_19, HutaM6Peritus5_20
      ]
    },
    {
      id: 5,
      name: 'Huta M8 Peritus',
      primary: HutaM8Peritus6Primary,
      gallery: [
        HutaM8Peritus6Primary,
        HutaM8Peritus6_46, HutaM8Peritus6_47, HutaM8Peritus6_48, HutaM8Peritus6_49, HutaM8Peritus6_50,
        HutaM8Peritus6_51, HutaM8Peritus6_52, HutaM8Peritus6_53, HutaM8Peritus6_54
      ]
    },
    {
      id: 6,
      name: 'Yuta C6 Peritus',
      primary: YutaC6Peritus1Primary,
      gallery: [
        YutaC6Peritus1Primary,
        YutaC6Peritus1_22, YutaC6Peritus1_23, YutaC6Peritus1_24, YutaC6Peritus1_25, YutaC6Peritus1_26,
        YutaC6Peritus1_27, YutaC6Peritus1_28, YutaC6Peritus1_29, YutaC6Peritus1_30, YutaC6Peritus1_31,
        YutaC6Peritus1_32, YutaC6Peritus1_33, YutaC6Peritus1_34, YutaC6Peritus1_35, YutaC6Peritus1_36,
        YutaC6Peritus1_37, YutaC6Peritus1_38, YutaC6Peritus1_39, YutaC6Peritus1_40, YutaC6Peritus1_41,
        YutaC6Peritus1_42, YutaC6Peritus1_43, YutaC6Peritus1_44
      ]
    },
    {
      id: 7,
      name: 'Huta M6 Auctor',
      primary: HutaM6Auctor8Primary,
      gallery: [
        HutaM6Auctor8Primary,
        HutaM6Auctor8_3236, HutaM6Auctor8_3238, HutaM6Auctor8_3241, HutaM6Auctor8_3246,
        HutaM6Auctor8_3248, HutaM6Auctor8_3260, HutaM6Auctor8_3273, HutaM6Auctor8_4820
      ]
    },
    {
      id: 8,
      name: 'Huta C7 Auctor',
      primary: HutaC7Auctor9Primary,
      gallery: [
        HutaC7Auctor9Primary,
        HutaC7Auctor9_7272, HutaC7Auctor9_7274, HutaC7Auctor9_7276, HutaC7Auctor9_7277,
        HutaC7Auctor9_7278, HutaC7Auctor9_7279, HutaC7Auctor9_7280, HutaC7Auctor9_7281,
        HutaC7Auctor9_7283, HutaC7Auctor9_7285, HutaC7Auctor9_7289, HutaC7Auctor9_7291,
        HutaC7Auctor9_7294, HutaC7Auctor9_7295, HutaC7Auctor9_7296
      ]
    },
    {
      id: 9,
      name: 'Huta M7 Auctor',
      primary: HutaM7Auctor10Primary,
      gallery: [
        HutaM7Auctor10Primary,
        HutaM7Auctor10_31, HutaM7Auctor10_32, HutaM7Auctor10_35, HutaM7Auctor10_36,
        HutaM7Auctor10_37, HutaM7Auctor10_38, HutaM7Auctor10_39, HutaM7Auctor10_42,
        HutaM7Auctor10_43, HutaM7Auctor10_44, HutaM7Auctor10_45, HutaM7Auctor10_46,
        HutaM7Auctor10_2370, HutaM7Auctor10_2377, HutaM7Auctor10_2379, HutaM7Auctor10_2381,
        HutaM7Auctor10_2384, HutaM7Auctor10_2385, HutaM7Auctor10_2394, HutaM7Auctor10_2401,
        HutaM7Auctor10_2405, HutaM7Auctor10_2413, HutaM7Auctor10_2430
      ]
    },
    {
      id: 10,
      name: 'Hackistalker M6 Auctor',
      primary: HackistalkerM6Auctor11Primary,
      gallery: [
        HackistalkerM6Auctor11Primary,
        HackistalkerM6Auctor11_2255, HackistalkerM6Auctor11_2257, HackistalkerM6Auctor11_2258,
        HackistalkerM6Auctor11_2259, HackistalkerM6Auctor11_2260, HackistalkerM6Auctor11_2261,
        HackistalkerM6Auctor11_2262, HackistalkerM6Auctor11_2263, HackistalkerM6Auctor11_2264,
        HackistalkerM6Auctor11_2266, HackistalkerM6Auctor11_2267, HackistalkerM6Auctor11_2269,
        HackistalkerM6Auctor11_2270, HackistalkerM6Auctor11_2271, HackistalkerM6Auctor11_2272,
        HackistalkerM6Auctor11_2273, HackistalkerM6Auctor11_2275, HackistalkerM6Auctor11_2276,
        HackistalkerM6Auctor11_2277, HackistalkerM6Auctor11_2278, HackistalkerM6Auctor11_2279,
        HackistalkerM6Auctor11_2280, HackistalkerM6Auctor11_2281, HackistalkerM6Auctor11_2282,
        HackistalkerM6Auctor11_2283, HackistalkerM6Auctor11_2284, HackistalkerM6Auctor11_2285
      ]
    },
    {
      id: 11,
      name: 'Hackistalker C6 Peritus',
      primary: HackistalkerC6Peritus12_1,
      gallery: [
        HackistalkerC6Peritus12_1, HackistalkerC6Peritus12_2, HackistalkerC6Peritus12_3,
        HackistalkerC6Peritus12_4, HackistalkerC6Peritus12_5, HackistalkerC6Peritus12_6,
        HackistalkerC6Peritus12_7, HackistalkerC6Peritus12_8, HackistalkerC6Peritus12_9,
        HackistalkerC6Peritus12_10, HackistalkerC6Peritus12_11, HackistalkerC6Peritus12_12,
        HackistalkerC6Peritus12_13, HackistalkerC6Peritus12_14, HackistalkerC6Peritus12_15
      ]
    },
    {
      id: 12,
      name: 'Yuta M5B Auctor',
      primary: YutaM5BAuctor13Primary,
      gallery: [
        YutaM5BAuctor13Primary,
        YutaM5BAuctor13_5088, YutaM5BAuctor13_5089, YutaM5BAuctor13_5090,
        YutaM5BAuctor13_5092, YutaM5BAuctor13_5096, YutaM5BAuctor13_5097,
        YutaM5BAuctor13_5098, YutaM5BAuctor13_5099, YutaM5BAuctor13_5101,
        YutaM5BAuctor13_5102, YutaM5BAuctor13_5103, YutaM5BAuctor13_5105,
        YutaM5BAuctor13_5107, YutaM5BAuctor13_5108, YutaM5BAuctor13_5109,
        YutaM5BAuctor13_5110
      ]
    },
  ];

  const openLightbox = (buildIndex) => {
    setCurrentBuildIndex(buildIndex);
    setCurrentImageIndex(0);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = () => {
    const totalImages = builds[currentBuildIndex].gallery.length;
    setCurrentImageIndex((prev) => (prev + 1) % totalImages);
  };

  const prevImage = () => {
    const totalImages = builds[currentBuildIndex].gallery.length;
    setCurrentImageIndex((prev) => (prev - 1 + totalImages) % totalImages);
  };

  const selectImage = (index) => {
    setCurrentImageIndex(index);
  };

  // Touch handlers for lightbox swipe
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextImage();
    } else if (isRightSwipe) {
      prevImage();
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      
      if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen]);

  // Custom styles for swiper
  const swiperStyles = `
    .builds-swiper {
      padding: 20px 0 60px 0 !important;
    }
    .builds-swiper .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 320px !important;
      height: 480px !important;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    .mobile-swiper {
      padding: 20px 0 0 0 !important;
    }
    .mobile-swiper .swiper-slide {
      width: 280px !important;
      height: 420px !important;
      margin-left: 10px !important;
      margin-right: 10px !important;
    }
    .builds-mobile-pagination {
      display: flex;
      justify-content: center;
      margin-top: 1.5rem;
    }
    .builds-mobile-pagination .swiper-pagination-bullet {
      background: rgba(255, 159, 102, 0.4) !important;
      width: 12px !important;
      height: 12px !important;
      margin: 0 6px !important;
      opacity: 1 !important;
    }
    .builds-mobile-pagination .swiper-pagination-bullet-active {
      background: #FF7A33 !important;
      transform: scale(1.1) !important;
      box-shadow: 0 0 8px rgba(255, 122, 51, 0.5) !important;
    }
    .builds-swiper .swiper-slide-active {
      transform: scale(1.05);
    }
    .builds-swiper .swiper-pagination {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .builds-swiper .swiper-pagination-bullet {
      background: rgba(255, 159, 102, 0.4) !important;
      width: 12px !important;
      height: 12px !important;
      margin: 0 6px !important;
      opacity: 1 !important;
    }
    .builds-swiper .swiper-pagination-bullet-active {
      background: #FF7A33 !important;
      transform: scale(1.1) !important;
      box-shadow: 0 0 8px rgba(255, 122, 51, 0.5) !important;
    }
    .builds-swiper .swiper-button-next,
    .builds-swiper .swiper-button-prev {
      color: #FF7A33 !important;
      transform: scale(0.8);
    }
    .builds-swiper .swiper-button-next:hover,
    .builds-swiper .swiper-button-prev:hover {
      transform: scale(0.9);
    }
    .lightbox-image {
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      will-change: transform;
    }
  `;

  return (
    <section id="gallery" className="py-32 bg-theme-bg-secondary relative">
      <style dangerouslySetInnerHTML={{ __html: swiperStyles }} />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-theme-primary-500/50 to-transparent"></div>
      
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-theme-primary-400 tracking-[0.2em] uppercase text-sm font-bold mb-2 block">Gallery</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">Recent Builds</h2>
        </div>
        
        {/* Desktop Swiper Carousel */}
        {!isMobile && (
          <div className="h-[600px] w-full">
            <Swiper
              modules={[Navigation, Pagination, EffectCoverflow, A11y, FreeMode]}
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              initialSlide={3}
              slidesPerView="auto"
              spaceBetween={60}
              loop={true}
              coverflowEffect={{
                rotate: 20,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              pagination={{ clickable: true, dynamicBullets: true }}
              navigation={true}
              className="builds-swiper h-full !pb-12"
            >
              {builds.map((build, index) => (
                <SwiperSlide key={build.id} onClick={() => openLightbox(index)} className="group !w-[350px] !h-[500px]">
                  <div className="relative w-full h-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl transition-all duration-500 group-hover:shadow-theme-primary-500/20 group-hover:border-theme-primary-500/30 cursor-pointer">
                    <img
                      src={build.primary}
                      alt={build.name}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-8">
                        <h3 className="text-2xl font-bold text-white mb-2 tracking-wide">{build.name}</h3>
                        <div className="flex items-center gap-2 text-theme-primary-400 text-sm font-medium">
                          <span>View Gallery</span>
                          <i className="fas fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        {/* Mobile Swiper Carousel */}
        {isMobile && (
          <div className="w-full">
            <Swiper
              modules={[Navigation, Pagination, A11y]}
              effect="slide"
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              initialSlide={3}
              loop={true}
              pagination={{ el: '.builds-mobile-pagination', clickable: true }}
              className="builds-swiper mobile-swiper"
            >
              {builds.map((build, index) => (
                <SwiperSlide key={build.id} onClick={() => openLightbox(index)} className="group !w-[280px] !h-[400px]">
                  <div className="relative w-full h-full rounded-xl overflow-hidden shadow-lg border border-white/10 cursor-pointer">
                    <img
                      src={build.primary}
                      alt={build.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-6">
                        <h3 className="text-xl font-bold text-white mb-1">{build.name}</h3>
                        <p className="text-xs text-theme-primary-400 uppercase tracking-wider">Tap to view</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="builds-mobile-pagination"></div>
          </div>
        )}
      </div>

      {/* Lightbox Gallery */}
      {lightboxOpen && (
        <div 
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center animate-fadeIn"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          {/* Close button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 text-white/50 hover:text-white text-5xl z-50 transition-colors leading-none focus:outline-none"
          >
            &times;
          </button>

          {/* Previous button */}
          <button
            onClick={prevImage}
            className="absolute left-6 top-1/2 -translate-y-1/2 text-white/20 hover:text-white text-6xl z-50 transition-colors focus:outline-none hidden md:block"
          >
            &#8249;
          </button>

          {/* Next button */}
          <button
            onClick={nextImage}
            className="absolute right-6 top-1/2 -translate-y-1/2 text-white/20 hover:text-white text-6xl z-50 transition-colors focus:outline-none hidden md:block"
          >
            &#8250;
          </button>

          {/* Main image */}
          <div
            className="w-full h-full flex items-center justify-center p-4 md:p-20 relative select-none"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <img
              src={builds[currentBuildIndex].gallery[currentImageIndex]}
              alt={`${builds[currentBuildIndex].name} - Image ${currentImageIndex + 1}`}
              className="max-w-full max-h-full object-contain shadow-2xl rounded-lg"
              loading="eager"
              decoding="async"
              draggable={false}
            />
            
            <div className="absolute bottom-8 left-0 right-0 text-center pointer-events-none">
              <h3 className="text-white text-xl font-bold drop-shadow-md mb-2">{builds[currentBuildIndex].name}</h3>
              <p className="text-gray-400 text-sm">{currentImageIndex + 1} / {builds[currentBuildIndex].gallery.length}</p>
            </div>
          </div>

          {/* Thumbnail navigation */}
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-black/50 backdrop-blur-md border-t border-white/10 flex items-center justify-center gap-2 px-4 overflow-x-auto hidden md:flex">
            {builds[currentBuildIndex].gallery.map((img, index) => (
              <button
                key={index}
                onClick={() => selectImage(index)}
                className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden transition-all duration-300 border-2 ${
                  index === currentImageIndex 
                    ? 'border-theme-primary-500 opacity-100 scale-110' 
                    : 'border-transparent opacity-40 hover:opacity-80 hover:border-white/30'
                }`}
              >
                <img 
                  src={img} 
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
